/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useCallback, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { makeSelectLocalStorageTableBtnActive } from '../../../modules/storage/storageSelectors';
import { ELocalStorageKeys } from '../../../modules/storage/storageTypes';
import { setButtonsMode } from '../../../modules/table/slice';
import { ETableButtonsMode } from '../../../modules/table/types';

export const useTableButtonsMode = () => {

    const tableBtnActive = useSelector(makeSelectLocalStorageTableBtnActive());

    useEffect(() => {
        if (tableBtnActive) {
            setButtonsMode({
                mode: ETableButtonsMode.disableAllExceptInArray,
                buttonsForCheckOnMode: [tableBtnActive],
            });
        }
    }, [tableBtnActive]);

    const clearPageTableButtonModeParameter = useCallback(() => {
        setButtonsMode({
            mode: null,
            buttonsForCheckOnMode: [],
        });
        localStorage.removeItem(ELocalStorageKeys.TABLE_BTN_ACTIVE);
    }, []);

    useEffect(() => {
        // clear mode if we go to gate or refresh page
        window.addEventListener('unload', clearPageTableButtonModeParameter, true);
        return () => {
            // clear mode if we go on another react page
            clearPageTableButtonModeParameter();
            window.removeEventListener('unload', clearPageTableButtonModeParameter, true);
        };
    }, [clearPageTableButtonModeParameter]);

    return { tableBtnActive }
}
